var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-in"},[_c('login-form',{ref:"loginForm",attrs:{"email":_vm.email,"password":_vm.password},on:{"loginByFacebook":_vm.loginByFacebook,"loginByPassword":_vm.loginByPassword}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }